import{createContext as r}from"react";var o,e=(o=r({onChange:function(){}})).Provider,n=o.Consumer;export{n as Consumer,e as Provider};
